import { SkeletonLoader } from '@/components/SkeletonLoader';

import { MeetingRoomCardSkeleton } from './MeetingRoomCardSkeleton';
import MeetingRoomSearchFiltersSkeleton from './MeetingRoomSearchFiltersSkeleton';

export default function MeetingRoomSearchSkeleton() {
  return (
    <div className="flex flex-col gap-10">
      <SkeletonLoader className="w-4/5 h-10" />
      <MeetingRoomSearchFiltersSkeleton />
      <MeetingRoomCardSkeleton />
      <hr className="border-slate-200" />
      <MeetingRoomCardSkeleton />
    </div>
  );
}
